import React, { useEffect } from 'react';
import moment from 'moment';
import { View, TouchableWithoutFeedback } from 'react-native-web';
import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { BodyText, Stack } from '../../../ui';
import { TimeTimerIcon } from '../../../ui/Icons/TimeTimerIcon';
import { useIsMobile, useLinkTo } from '../../../../hooks';
import { BOOKING_ROUTE } from '../../../../route-names';
import { clickable } from '../../../../styles';

export type LimitedAvailabilityBannerProps = {
  providerName: string;
  providerId?: number | string;
  topBookableServiceId?: number;
  providerBookable: boolean;
  onPress?: () => void;
};

export const getMonthName = (fromDate?: string | object | Date) => {
  const sevenDaysFromTime = moment(fromDate).add(7, 'days');
  return sevenDaysFromTime.format('MMMM');
};

export const LimitedAvailabilityBanner: React.FCWithChildren<LimitedAvailabilityBannerProps> = ({
  providerId,
  providerName,
  topBookableServiceId,
  providerBookable,
  onPress = () => { },
}) => {
  const isMobile = useIsMobile();
  const [rotation, setRotation] = React.useState<number>(0);
  const firstName = providerName?.split(' ')[0];
  const linkTo = useLinkTo();

  useEffect(() => {
    // this interval will rotate the svg clock icon's hand 3 times before stopping
    const interval = setInterval(() => {
      if (rotation <= 60) {
        setRotation(rotation + 20);
      } else {
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  });

  const handlePress = () => {
    onPress();

    if (providerBookable && topBookableServiceId) {
      linkTo(BOOKING_ROUTE, { providerId, serviceId: topBookableServiceId });
    }
  };

  return (
    <TouchableWithoutFeedback onPress={handlePress}>
      <View
        style={clickable}
        testID="limited-availability-banner"
      >
        <Box paddingX={isMobile ? 16 : 0} paddingBottom={4} alignItems={isMobile ? 'stretch' : 'stretch'}>
          <Inline
            paddingY={12}
            paddingX={12}
            borderWidth={1}
            borderStyle="solid"
            borderColor={BrandColor.LightGrey}
            borderRadius={8}
            alignItems="center"
          >
            <Box paddingRight={8}>
              <TimeTimerIcon
                width={22}
                height={22}
                handRotation={rotation}
                color={BrandColor.Yellow}
                handColor={BrandColor.Yellow}
              />
            </Box>
            <Stack flex={1} paddingRight={4}>
              <BodyText appearance="medium" weight="bold">Limited Availability!</BodyText>
              <BodyText appearance="medium" testID="limited-availability-banner-text">
                {firstName.endsWith('s') ? `${firstName}'` : `${firstName}'s`}
                {` calendar is filling up for ${getMonthName()} - secure your spot now.`}
              </BodyText>
            </Stack>
          </Inline>
        </Box>
      </View>
    </TouchableWithoutFeedback>
  );
};

export default LimitedAvailabilityBanner;
